import * as React from 'react';
import { Autocomplete, Box, TextField, FormControl } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { GridColDef } from '@mui/x-data-grid';
import { TestCombination, TestComboSupportVal, getTestCombinationList, getTestComboSupport } from '../../../types/TestCombinations';
import { EditableTable } from '../../../subs/EditableTable';

import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../../../contexts/SnackBarContext';

export const TestComboSupportAdminView = () => {
    const { showSnackbar } = useSnackbar();
    const [testCombinations, setTestCombinations] = React.useState<TestCombination[]>([]);
    const [selectedTestCombination, setSelectedTestCombination] = React.useState<TestCombination>();
    const [allData, setallData] = React.useState<TestComboSupportVal[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetchAllTestCombinations = async () => {
            const allTestCombinationsResponse = await getTestCombinationList(new AbortController());
            if (allTestCombinationsResponse.failed) {
                showUserFeedback(allTestCombinationsResponse.errorText);
                return;
            }
            setTestCombinations(allTestCombinationsResponse.result);
        }
        fetchAllTestCombinations();
    }, [showUserFeedback]);

    React.useEffect(() => {
        const fetchAllProducts = async () => {
            if (!selectedTestCombination) return;
            const testComboVal: TestComboSupportVal = {
                id: 0,
                testCombinationId: selectedTestCombination?.id ?? 0
            }
            const allProductsResponse = await getTestComboSupport(testComboVal, new AbortController());
            if (allProductsResponse.failed) {
                showUserFeedback(allProductsResponse.errorText);
                return;
            }
            setallData(allProductsResponse.result);
        }
        fetchAllProducts();
    }, [selectedTestCombination, showUserFeedback]);

    const columns: GridColDef[] = [
        {
            field: 'testCombinationId',
            headerName: 'Test Combination ID',
            flex: 1
        },
        {
            field: 'interfaceId',
            headerName: 'Interface ID',
            flex: 1
        },
        {
            field: 'testCaseId',
            headerName: 'Test Case ID',
            flex: 1
        },
        {
            field: 'interfacePropertyId',
            headerName: 'Interface Property ID',
            flex: 1
        },
        {
            field: 'id',
            headerName: 'ID',
            flex: 1
        }
    ];

    return <React.Fragment >
        <Grid size={6} paddingBottom={10}>
            <FormControl required fullWidth>
                <Autocomplete id='ac-tcOptions' options={testCombinations.map(w => w.combinationName)}
                    value={selectedTestCombination ? selectedTestCombination.combinationName : ''}
                    onChange={(e, value) => setSelectedTestCombination(testCombinations.find(w => w.combinationName === value))}
                    renderInput={(params) =>
                        <TextField name='tcOptions' multiline
                            {...params}
                            label={"Test Combination"}
                            sx={{
                                '& .MuiOutlinedInput-root fieldset': {
                                    borderColor: 'divider',
                                },
                                '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                                    borderColor: 'divider',
                                },
                            }}
                        />
                    }
                />
            </FormControl>
        </Grid>
        <Box sx={{ flexGrow: 1, width: "100%" }} style={{ overflow: 'auto' }}>
            <EditableTable
                columns={columns}
                rows={allData}
                setAllRows={setallData}
            />
        </Box>
    </React.Fragment >
}